import { useSnackbar } from 'notistack';

let useSnackbarRef;

export const SnackbarInitializer = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

const Snackbar = {
  success(message) {
    useSnackbarRef.enqueueSnackbar(message ?? 'Success', {
      variant: 'success',
    });
  },
  warning(message) {
    useSnackbarRef.enqueueSnackbar(message ?? 'Warning', {
      variant: 'warning',
    });
  },
  error(error) {
    useSnackbarRef.enqueueSnackbar(
      typeof error !== 'string'
        ? error?.response?.data?.message ||
            error?.response?.data ||
            error?.message ||
            'Something Went Wrong'
        : error,
      { variant: 'error' },
    );
  },
};

export default Snackbar;
